import { notification } from "antd";
import { takeLatest, put } from "redux-saga/effects";
import {
  FETCH_LIVE_WELD_STATUS_SAGA,
  FETCH_LIVE_WELD_STATUS_SUCCESS,
  FETCH_LIVE_WELD_STATUS_FAILURE,
  START_WELD_STATUS_LOADER,
  CHANGE_WELD_NUMBER,
  CHANGE_WELD_NUMBER_WITH_UID,
} from "./types";
import { ADMIN_URL } from "../../config";
import fetch from "../../services/fetch";

function* fetchWeldStatus(action) {
  try {
    yield put({ type: START_WELD_STATUS_LOADER });

    const { project_id, project_name } = action.payload;

    const url = new URL(`${ADMIN_URL}/v1/weld-status`);
    if (project_id) url.searchParams.append("project_id", project_id);
    if (project_name) url.searchParams.append("project_name", project_name);

    const res = yield fetch(url.toString(), {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      yield put({
        type: FETCH_LIVE_WELD_STATUS_SUCCESS,
        payload: {
          data: response.data.data,
          weldParameterErrors: response.data.weldParameterErrors || null,
        },
      });
    } else {
      throw new Error(response.message || "Failed to fetch weld status");
    }
  } catch (error) {
    console.error("Fetch weld status error:", error);
    yield put({
      type: FETCH_LIVE_WELD_STATUS_FAILURE,
      payload: error.message,
    });
    notification.error({
      message: "Error fetching weld status",
      description: error.message,
    });
  }
}

function* changeWeldNumber(action) {
  try {
    const { project_id, old_weld_number, new_weld_number } = action.payload;

    const res = yield fetch(`${ADMIN_URL}/v1/weld-status/change-weld-number`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        project_id,
        old_weld_number,
        new_weld_number,
      }),
    });

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      notification.success({
        message: "Success",
        description: "Weld number changed successfully",
      });
    } else {
      throw new Error(response.message || "Failed to change weld number");
    }
  } catch (error) {
    console.error("Change weld number error:", error);
    notification.error({
      message: "Error changing weld number",
      description: error.message,
    });
  }
}

function* changeWeldNumberWithUid(action) {
  try {
    const { project_id, old_weld_number, new_weld_number, weld_uid } =
      action.payload;

    const res = yield fetch(
      `${ADMIN_URL}/v1/weld-status/change-weld-number-with-uid`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          project_id,
          old_weld_number,
          new_weld_number,
          weld_uid,
        }),
      }
    );

    if (res.status === 403) {
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (response.statusCode === 200) {
      notification.success({
        message: "Success",
        description: "Weld number changed successfully",
      });
    } else {
      throw new Error(response.message || "Failed to change weld number");
    }
  } catch (error) {
    console.error("Change weld number with UID error:", error);
    notification.error({
      message: "Error changing weld number",
      description: error.message,
    });
  }
}

export default function* data360LiveSlogDataSaga() {
  yield takeLatest(FETCH_LIVE_WELD_STATUS_SAGA, fetchWeldStatus);
  yield takeLatest(CHANGE_WELD_NUMBER, changeWeldNumber);
  yield takeLatest(CHANGE_WELD_NUMBER_WITH_UID, changeWeldNumberWithUid);
}
